import { useBreakpoints } from './use-breakpoints.js';

/**
 * Hook to retrieve the currently active breakpoint. It returns null if the window size is smaller
 * than the smallest defined breakpoint.
 */ function useActiveBreakpoint() {
    const breakpoints = useBreakpoints();
    return [
        ...breakpoints.entries()
    ].findLast(([, active])=>active)?.[0] ?? null;
}

export { useActiveBreakpoint };
//# sourceMappingURL=use-active-breakpoint.js.map
